import { AfterViewInit, ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'link-indicator',
  templateUrl: './link-indicator.component.html',
  styleUrls: ['./link-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkIndicatorComponent {
  template = '';
  @Input() color: string;
  @Input() name: string;
  @Input() set isRestricted(v: boolean) {
    if (!v) return;
    this.template = `<div>${this.name} <i class='font-icon icon-lock-fill'></i></div>`;
  }

  colorClassName = {
    'ml-c1': 'primary',
    'ml-c2': 'orange',
    'ml-c3': 'yellow',
    'ml-c4': 'red',
    'ml-c5': 'purple',
    'ml-c6': 'teal',
    'ml-c7': 'light-orange',
    'ml-c8': 'green',
  };
}
